import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { InputGroup } from 'react-bootstrap';
import { Input } from 'components';
import styled, { css } from 'styled-components';

const InputPassword = ({ name, placeholder, register, nolabel, ...rest }) => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  return (
    <Container>
      <Input
        type={show ? 'text' : 'password'}
        name={name}
        placeholder={placeholder}
        ref={register}
        autoComplete="off"
        nolabel={nolabel}
        className="w-100"
        {...rest}
      />
      <Icon onClick={handleClick}>{show ? <EyeSlash /> : <Eye />}</Icon>
    </Container>
  );
};

const iconStyles = css`
  color: ${(props) => props.theme.input.iconColor};
  font-size: 1.5rem;
`;

const EyeSlash = styled(FaEyeSlash)`
  ${iconStyles}
`;
const Eye = styled(FaEye)`
  ${iconStyles}
`;

const Container = styled(InputGroup)`
  display: block;
`;

const Icon = styled(InputGroup.Append)`
  position: absolute;
  top: 0.7rem;
  right: 0.5rem;
  z-index: 4;
  cursor: pointer;
`;

export default InputPassword;
